import SuperAdminPrototype from "./SuperAdminPrototype";

export default SuperAdminPrototype;
